<template>
	<div class="user-provided-file">
		<b-modal
			:id="`file-browser-${modalId}`"
			size="lg"
			title="File Browser"
			@ok="confirmFileId"
		>
			<FileBrowser @fileSelected="setFileId" />
		</b-modal>
		<div v-if="!(fileUri || fileUrl)">
			<b-button
				v-if="editable"
				v-b-modal="`file-browser-${modalId}`"
				variant="secondary"
				class="btn-small"
			>
				Upload File
			</b-button>
		</div>
		<div v-else>
			<span v-if="displayInline">
				<div>
					<img :src="fileUrl">
					<b-icon
						v-if="editable"
						v-b-modal="`file-browser-${modalId}`"
						icon="pencil-square"
						class="modify-image-link"
					/>
				</div>
			</span>
			<span v-else>
				<b-link @click="downloadUri">{{ fileDetails.name }}</b-link>
				<b-icon
					v-if="editable"
					v-b-modal="`file-browser-${modalId}`"
					icon="pencil-square"
				/>
			</span>
		</div>
	</div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import FileBrowser from '@/components/Files/FileBrowser.vue';

export default {
	name: 'UserFile',
	components: {
		FileBrowser,
	},
	props: {
		fileUri: { type: String, default: '' },
		static: { type: Boolean, default: false },
	},
	data() {
		return {
			modalId: null,
			selectedFile: null,
			fileUrl: null,
			fileHash: null,
			displayInline: false,
			fileDetails: {},
			editable: !this.static && this.$store.state.user.currentEnterprise.enterprise_user.role !== 'VIEWER',
		};
	},
	watch: {
		fileUri: function fileChanged(newVal) {
			if (newVal && newVal.startsWith('dmp:file:')) {
				this.loadUri(newVal.replace('dmp:file:', ''));
			} else {
				this.unloadUri();
			}
		},
	},
	created() {
		// necessary as UserFile can be added several times to the same parent component (e.g. FileManager)
		this.modalId = uuid().toString();
		if (this.fileUri && this.fileUri.startsWith('dmp:file:')) this.loadUri(this.fileUri.replace('dmp:file:', ''));
	},
	beforeDestroy() {
		if (this.fileUrl) URL.revokeObjectURL(this.fileUrl);
	},
	methods: {
		setFileId(data) {
			// store emitted URI from FileBrowser
			this.selectedFile = data;
		},
		confirmFileId() {
			// confirm selected URI from FileBrowser modal
			this.loadUri(this.selectedFile.replace('dmp:file:', ''));
			this.$emit('fileSelected', this.selectedFile);
		},
		unloadUri() {
			this.fileUrl = null;
			this.fileHash = null;
			this.displayInline = false;
			this.fileDetails = {};
		},
		loadUri(uri) {
			// expects a UUID referring to a File
			// remove the "dmp:file:" URI protocol before passing in
			if (!uri) return false;
			if (this.fileDetails && this.fileDetails.type && this.fileDetails.type.startsWith('image')) {
				this.axios
					.get(`/files/${uri}`, { responseType: 'blob' })
					.then((blob) => {
						this.fileUrl = URL.createObjectURL(blob.data);
						this.displayInline = true;
					})
					.catch((error) => {
						console.error(error);
					});
			} else {
				this.displayInline = false;
				this.axios
					.get(`/files/${uri}/metadata`)
					.then((response) => {
						this.fileDetails = response.data;
						// if the file type is an image and can be displayed inline, fetch now
						if (this.fileDetails.type.startsWith('image')) {
							this.axios
								.get(`/files/${uri}`, { responseType: 'blob' })
								.then((blob) => {
									// https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications#example_using_object_urls_to_display_images
									// https://alphahydrae.com/2021/02/how-to-display-an-image-protected-by-header-based-authentication/
									// https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
									this.fileUrl = URL.createObjectURL(blob.data);
									this.displayInline = true;
								})
								.catch((error) => {
									console.error(error);
								});
						}
					})
					.catch((error) => {
						console.error(error);
					});
			}
			return true;
		},
		downloadUri() {
			// creates an ObjectUrl to initiate local download
			if (this.fileDetails) {
				let uri = this.fileUri;
				uri = uri.replace('dmp:file:', '');
				this.axios
					.get(`/files/${uri}/metadata`)
					.then((data) => {
						this.fileDetails = data.data;
						this.axios.get(`/files/${uri}`, { responseType: 'blob' }).then((blob) => {
							this.fileUrl = URL.createObjectURL(blob.data);
							window.open(this.fileUrl);
						});
					})
					.catch((error) => {
						console.error(error);
					});
			}
		},
	},
};
</script>

<style>
.modify-image-link {
	position: relative;
	right: 5px;
	bottom: 5px;
	cursor: pointer;
}
.user-file-upload {
	display: none;
}
</style>
